export const API_ENDPOINT_PREFIX = "https://api.atstake.net/prod/";
//export const API_ENDPOINT_PREFIX = "https://api.atstake.net/test/"; // Justin's test environment
//export const API_ENDPOINT_PREFIX = "https://api.atstake.net/vnext/"; // Elliot's test environment
